<template>
<div class="container pt-3 pb-3">
<div class="subscribe-wrap col-md-8 offset-md-2">
    <div class="card">
        <div class="card-header py-3">{{registerViaAdmin ? lang.app.register.admin_mode_title : lang.app.register.title }}</div>
        <div class="card-body pt-4">
            <alert-ele v-show="messageText" :message="messageText" :status="messageStatus" @dismiss="()=>this.messageStatus = null"/>
        <div class="form-group row">
            <label for="first_name"
                   class="col-md-4 col-form-label text-md-right">{{ lang.app.global.first_name }}</label>
            <div class="col-md-6">
                <input
                        id="first_name" type="text"
                        class="form-control"
                        name="first_name"
                        v-model="form.first_name"
                        required
                        autocomplete="none"
                        :placeholder="lang.app.global.first_name"
                >
                <error-ele v-if="formValidationErrors && formValidationErrors['first_name']"
                           :errors="formValidationErrors['first_name']"/>
            </div>
        </div>
        <div class="form-group row">
            <label for="last_name"
                   class="col-md-4 col-form-label text-md-right">{{ lang.app.global.last_name }}</label>
            <div class="col-md-6">
                <input
                        id="last_name" type="text"
                        class="form-control"
                        name="last_name"
                        v-model="form.last_name"
                        required
                        autocomplete="none"
                        :placeholder="lang.app.global.last_name"
                >
                <error-ele v-if="formValidationErrors && formValidationErrors['last_name']"
                           :errors="formValidationErrors['last_name']"/>
            </div>
        </div>
        <div class="form-group row">
            <label for="register-email"
                   class="col-md-4 col-form-label text-md-right">{{ lang.app.global.email }}</label>
            <div class="col-md-6">
                <input
                        id="register-email" type="email"
                        class="form-control"
                        name="email"
                        v-model="form.email"
                        @blur="validateEmail"
                        required
                        autocomplete="none"
                        :placeholder="lang.app.global.email"
                >
                <div v-if="formValidationErrors && formValidationErrors['email']">
                    <template v-if="userAlreadyExists">
                        <div v-if="!registerViaAdmin || !(s2fOnboardedUser || apiFarmer)" class="invalid-feedback" style="display: block">
                            <span>Dit mailadres is al gekoppeld aan een Farmdesk licentie.</span>
                            <a v-if="!registerViaAdmin" :href="this.loginRedirectUrl">Klik hier om in te loggen</a>
                        </div>
                        <div v-else class="info-feedback">
                            <span>Dit email adres werd gebruikt in een onboarding. U kan de gegevens verder aanvullen.</span>
                        </div>
                    </template>
                    <error-ele v-else :errors="formValidationErrors['email']"/>
                </div>

            </div>
        </div>

        <div class="form-group row">
            <label for="telephone"
                   class="col-md-4 col-form-label text-md-right">{{ lang.app.global.telephone }}</label>
            <div class="col-md-6">
                <input
                        id="telephone" type="text"
                        class="form-control"
                        name="telephone"
                        v-model="form.telephone"
                        required
                        :placeholder="lang.app.global.telephone"
                >
                <error-ele v-if="formValidationErrors && formValidationErrors['telephone']"
                           :errors="formValidationErrors['telephone']"/>
            </div>
        </div>

<!--        <template v-if="registerViaAdmin">-->
<!--            <div class="form-group row">-->
<!--                <label for="salesforce_id"-->
<!--                       class="col-md-4 col-form-label text-md-right">Salesforce id</label>-->
<!--                <div class="col-md-6">-->
<!--                    <input-->
<!--                        id="salesforce_id" type="text"-->
<!--                        class="form-control"-->
<!--                        name="salesforce_id"-->
<!--                        v-model="form.salesforce_id"-->
<!--                        placeholder="Salesforce id"-->
<!--                    >-->
<!--                    <error-ele v-if="formValidationErrors && formValidationErrors['salesforce_id']"-->
<!--                               :errors="formValidationErrors['salesforce_id']"/>-->
<!--                </div>-->
<!--            </div>-->
<!--        </template>-->
        <template v-if="!registerViaAdmin">
            <div class="form-group row">
                <label for="password"
                       class="col-md-4 col-form-label text-md-right">{{ lang.app.global.password }}</label>
                <div class="col-md-6">
                    <input
                        id="password" type="password"
                        class="form-control"
                        name="password"
                        v-model="form.password"
                        required
                        :placeholder="lang.app.global.password"
                    >
                    <error-ele v-if="formValidationErrors && formValidationErrors['password']"
                               :errors="formValidationErrors['password']"/>
                </div>
            </div>

            <div class="form-group row">
                <label for="confirm_password"
                       class="col-md-4 col-form-label text-md-right">{{ lang.app.global.confirm_password }}</label>
                <div class="col-md-6">
                    <input
                        id="confirm_password" type="password"
                        class="form-control"
                        name="confirm_password"
                        v-model="form.confirm_password"
                        required
                        :placeholder="lang.app.global.confirm_password"
                    >
                    <error-ele v-if="formValidationErrors && formValidationErrors['confirm_password']"
                               :errors="formValidationErrors['confirm_password']"/>
                </div>
            </div>
        </template>

        <div class="form-group row">
            <label for="user_role"
                   class="col-md-4 col-form-label text-md-right">{{ lang.app.register.user_role }}</label>
            <div class="col-md-6">
                <select
                        id="user_role"
                        class="form-control"
                        name="user_role"
                        v-model="form.farmer.is_professional"
                        required
                        autocomplete="none"
                >
                    <option :value="null">{{ lang.app.register.select }}</option>
                    <option v-bind:value="true">{{ lang.app.register.pro_dairy_farmer }}</option>
                    <option v-bind:value="false" :disabled="registerViaAdmin">{{ lang.app.register.not_pro_dairy_farmer }}</option>

                </select>
                <error-ele
                        v-if="formValidationErrors && formValidationErrors['farmer.is_professional']"
                        :errors="formValidationErrors['farmer.is_professional']"/>
            </div>
        </div>
        <div class="form-group row" v-if="form.farmer.is_professional">
            <label for="animal_type"
                   class="col-md-4 col-form-label text-md-right">{{ lang.app.profile.animal_type }}</label>
            <div class="col-md-6">
                <select
                        id="animal_type"
                        class="form-control"
                        name="animal_type"
                        v-model="form.farmer.animal_type"
                        autocomplete="none"
                        :placeholder="lang.app.profile.animal_type"
                >
                    <option disabled :value="null">{{ lang.app.profile.select }}</option>

                    <option v-for="animalType in animalTypes" :value="animalType.value">
                        {{ animalType.label }}
                    </option>


                </select>
                <error-ele
                        v-if="formValidationErrors &&
                                            formValidationErrors['farmer.animal_type']"
                        :errors="formValidationErrors['farmer.animal_type']"/>
            </div>
        </div>
        <div class="form-group row" v-if="registerViaAdmin && form.farmer.is_professional">
            <label for="advisors-selector"
                   class="col-md-4 col-form-label text-md-right">Advisors</label>
            <div class="col-md-6">
                <multiselect
                        name="advisors-selector"
                        v-model="selectedAdvisorOptions"
                        :options="advisorOptions"
                        :multiple="true"
                        track-by="value"
                        label="label"
                        :internal-search="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                />
                <error-ele
                    v-if="formValidationErrors &&
                                        formValidationErrors['farmer.advisors.0']"
                    :errors="formValidationErrors['farmer.advisors.0']"/>
            </div>
        </div>
        <div v-if="form.farmer.is_professional === false || (form.farmer.is_professional && form.farmer.animal_type)"
             class="form-group row">
            <div class="col-md-6 offset-md-4">
                <template v-if="!registerViaAdmin">
                    <small><label for="accept_privacy_policy" class="mb-0">
                        <input
                            id="accept_privacy_policy" type="checkbox"
                            name="accept_privacy_policy"
                            v-model="form.accept_privacy_policy"
                            required
                        >
                        <span>
                        Ik ga akkoord met de
                        <u><a :href="(form.farmer.is_professional === false || cowTypes.indexOf(form.farmer.animal_type) >= 0) ? route('license-agreement-nl') : route('contact')"
                              class="text-black"
                              target="_blank">
                            Farmdesk gebruikersovereenkomst
                        </a></u>
                    </span>
                    </label></small>
                    <error-ele v-if="formValidationErrors && formValidationErrors['accept_privacy_policy']"
                               :errors="formValidationErrors['accept_privacy_policy']"/>
                    <br/>
                </template>
                <small>
                    Wij waarderen uw privacy! Lees
                    <u><a :href="route('privacy-declaration')"
                          class="text-black" target="_blank">
                        hier
                    </a></u> onze privacyverklaring.
                </small>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-6 offset-4">
                <button-loader
                        :isLoading="registerButtonLoader"
                        :disabled="registerButtonLoader || (userAlreadyExists && (!registerViaAdmin || !(s2fOnboardedUser || apiFarmer)))"
                        :classes="'btn btn-black background-' + this.product + ' px-md-4'"
                        @click="submitForm()"
                > {{ lang.app.register.register_btn }}
                </button-loader>

            </div>
        </div>
        </div>
    </div>
</div>
</div>
</template>
<style scoped>
    .info-feedback {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #2C4A88;
    }
</style>
<script>
    import Multiselect from 'vue-multiselect';
    import 'vue-multiselect/dist/vue-multiselect.min.css';

    export default {
        components: {
            Multiselect
        },

        props: ['product', 'isProfessional', 'animalTypes', 'registerViaAdmin', 'advisorOptions', 'apiFarmer'],
        data() {
            const getCreateSubscriptionUrl = route('Subscription.GetCreateProductSubscription',{
                'locales': locale,
                'product': this.product
            });
            const loginRedirectUrl = route('Auth.GetLogIn', {
                'locales': locale,
                'product': this.product,
                'redirect_url': getCreateSubscriptionUrl
            })

            const cowTypes = [];
            if (this.animalTypes) {
                for (const animal of this.animalTypes) {
                    if (animal['value'].startsWith('cow')) {
                        cowTypes.push(animal['value']);
                    }
                }
            }

            let selectedAdvisorOptions = [];
            if (this.apiFarmer && this.apiFarmer.advisors) {
                selectedAdvisorOptions = _.filter(this.advisorOptions, (o) => {return this.apiFarmer.advisors.indexOf(o.value) > -1});
            }

            return {
                form: this.getDefaultForm(),
                cowTypes: cowTypes,
                registerButtonLoader: false,
                getCreateSubscriptionUrl: getCreateSubscriptionUrl,
                loginRedirectUrl: loginRedirectUrl,
                selectedAdvisorOptions: selectedAdvisorOptions,
                userAlreadyExists: false,
                s2fOnboardedUser: false,
                messageText: '',
                messageStatus: '',
            }
        },

        methods: {

            getDefaultForm() {
                let password = null;
                let accept_privacy_policy = false;
                if (this.registerViaAdmin) {
                    password = 'N^UU3G#hcW9v%u&2&^#%';
                    accept_privacy_policy = true;
                }

                const form = {
                    first_name: null,
                    last_name: null,
                    email: null,
                    telephone: null,
                    password: password,
                    confirm_password: password,
                    farmer: {
                        is_professional: this.isProfessional,
                        animal_type: null,
                        advisors: [],
                },
                    accept_privacy_policy: accept_privacy_policy,
                    referrer_url: document.referrer,
                    product: this.product,
                    salesforce_id: null
                };

                if (this.apiFarmer) {
                    form['first_name'] = this.apiFarmer.user.first_name;
                    form['last_name'] = this.apiFarmer.user.last_name;
                    form['email'] = this.apiFarmer.user.email;
                    form['telephone'] = this.apiFarmer.user.telephone;
                    form['salesforce_id'] = this.apiFarmer.user.salesforce_id;
                    form['farmer'] = {
                        is_professional: true,
                        animal_type: this.apiFarmer.animal_type,
                        advisors: this.apiFarmer.advisors,
                    };
                    delete form['referrer_url']
                }
                return form;
            },

            submitForm() {
                this.formError = null;
                this.registerButtonLoader = true;

                const selectedAdvisorIds = [];
                for (const item of this.selectedAdvisorOptions) {
                    selectedAdvisorIds.push(item.value)
                }
                this.form.farmer.advisors = selectedAdvisorIds;

                return api.auth
                    .postRegister(this.form)
                    .then(response => {
                        const urlParams = {};
                        if (this.registerViaAdmin) {
                            urlParams['user_id'] = response.data.id;
                            window.location.href = route('Admin.User.GetEdit',urlParams);
                        } else {
                            urlParams['locales'] = locale;
                            urlParams['product'] = this.product;
                            window.location.href = route('User.Profile.GetEdit',urlParams);
                        }
                    })
                    .catch(error => {
                        this.userAlreadyExists = false;
                        this.s2fOnboardedUser = false;
                        if (!error.response || error.response.status !== 422) {
                            return;
                        }
                        if (error.response.data) {
                            if (error.response.data.error) {
                                this.messageText = error.response.data.error;
                                this.messageStatus = 'error';
                            } else {
                                this.formError = error.response.data;
                            }

                        }
                    })
                    .finally(() => {
                        this.registerButtonLoader = false;
                    });
            },

            validateEmail(){
                let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (!this.form.email || !this.form.email.match(mailformat)) {
                    return;
                }

                this.formError = null;
                this.userAlreadyExists = false;
                this.s2fOnboardedUser = false;
                api.user.postValidateEmailAction({email: this.form.email})
                    .then(response => {})
                    .catch(error => {
                        if (error.response.status === 422 && error.response && error.response.data) {
                            this.formError = error.response.data;
                            if (this.formError['errors']['email'][0] === 'must_be_unique') {
                                this.userAlreadyExists = true
                                if (['seed2feed_intake_onboarding', 'seed2feed_intake_onboarded'].indexOf(this.formError['body']['account_status']) > -1) {
                                    this.s2fOnboardedUser = true;
                                    this.form.farmer.is_professional = true;
                                }
                            }
                        }
                        this.registerButtonLoader = false;
                    });
            }

        },

    }
</script>



// WEBPACK FOOTER //
// resources/js/components/auth/register/Form.vue